export const validateEmail = (email: string) => {
  const pattern = /^[a-zA-Z0-9_!#$%&'*+/=?`{|}~^.-]+@[a-zA-Z0-9.-]+$/
  return pattern.test(email) && email.length <= 300
}
